import styled from 'styled-components';
import scrollBar from '../../userDocuments/editDocument/UI/Editor/shared/scrollBar';
import {
  Gray94,
  white,
  Black,
  PrimaryDark,
  PrimaryDarkRGBA,
  LightShadeGray,
} from '../../../styling/theme';

export const CommentPopup = styled.div`
  background-color: ${white};
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  position: absolute;
  line-height: 32px;
  /* padding: 12px; */
  min-width: ${({ isContextMenu }) => (isContextMenu ? '200px' : '340px')};
  max-width: 340px;
  top: ${(props) => `${props.top}px`};
  left: ${(props) => `${props.left}px`};
  font-weight: normal;
  font-size: 16px;
  border-radius: 4px;
  z-index: 3;
  box-sizing: border-box;
  display: block;
  text-transform: none;
  color: ${Black};
  overflow: overlay;
  pointer-events: all;
  ${() => scrollBar({ width: '6px', height: '6px' })}
  /* resize: both; */

  i {
    position: absolute;
    bottom: 100%;
    left: 4%;
    margin-left: -12px;
    width: 24px;
    height: 12px;
    overflow: hidden;
  }

  i::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    left: 58%;
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: #f9f8f0;
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
  }
`;

export const Comments = styled.div`
  max-height: 300px;
  overflow: overlay;
  overflow-x: hidden;
  ${() => scrollBar({ width: '4px', height: '4px' })};
  padding: 8px 20px;
`;

export const UserProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

export const UserIcon = styled.img`
  float: left;
  max-width: 32px;
  width: 100%;
  margin: 0 12px 0 0;
  border-radius: 50%;
`;

export const UserName = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const User = styled.div`
  display: flex;
  justify-content: ${(props) => props.currUser && 'flex-end'};
  height: 26px;
`;

export const TimeWrapper = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 11px;
  padding: 0px 10px;
  color: #535353;
`;

export const UserProfile = styled.span`
  display: flex;
`;

export const Message = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  line-height: 18px;
  background: ${(props) => (props.currUser ? '#E8EAF6' : '#f5f5f5')};
  border-radius: 2px;
  text-align: left;
  white-space: pre-wrap;
  width: 80%;
  position: relative;
  /* margin: 8px 0px; */
`;

export const MessageText = styled.p`
  /* padding: 5px 0px; */
  font-size: 13px;
  word-break: break-word;
`;

export const DeleteIconWrapper = styled.div`
  cursor: pointer;
  /* display: flex;
  justify-content: flex-end; */
  padding: 0 6px;
`;

export const DeleteSpan = styled.span``;

export const SendMessageWrapper = styled.div`
  background: rgba(162, 162, 162, 0.1);
`;

export const MessageWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 10px 0;
  border-radius: 4px;
  font-size: 13px;
  position: relative;
  padding: 4px 0 0 0;
`;

export const TextArea = styled.div`
  outline: none;
  width: 90%;
  min-height: 48px;
  line-height: 1.75;
  overflow-y: auto;
  background: none;
  border: none;
  resize: none;
  padding: 4px 0 0 4px;
  z-index: 1;
  text-align: left;
  cursor: text;
`;

export const PlaceHolder = styled.span`
  position: absolute;
  z-index: 0;
  color: gray;
  left: 22px;
  top: 4px;
`;

export const Send = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  cursor: pointer;
  margin: 0 0 0 12px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 16px 0;
  font-size: 14px;
`;

export const DeleteMessageWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => props.currUser && 'flex-end'};
  /* padding: 0px 4px; */
`;

export const ShowComments = styled.span`
  border-radius: 4px;
  padding: 4px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 28px;
  font-size: 14px;
  font-weight: 400;
  cursor: ${(props) => (props.restrictCursor ? 'no-drop' : 'pointer')};
  text-align: left !important;
  &:hover {
    background: ${Gray94};
  }
`;

export const CommentIndex = styled.span``;

export const Arrow = styled.span``;

export const Button = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  font-size: 12px;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
  padding: 3px 10px;
`;

export const MsgBtn = styled(Button)`
  display: ${(props) => props.loading && 'none'};
  background: ${(props) =>
    !props?.commentString?.length ? PrimaryDarkRGBA(0.5) : PrimaryDark}};
  cursor: ${(props) => !props?.commentString?.length && 'not-allowed'};
  color: ${white};
`;

export const CommentNumbers = styled.div`
  display: ${(props) => (props.isContextMenu ? 'block' : 'none')};
  padding: 8px;
`;

export const CommentsData = styled.div`
  display: ${(props) => (props.commentCard ? 'block' : 'none')};
`;

export const Spinner = styled.span`
  display: flex;
  margin: 24px 0;
  justify-content: space-around;
`;

export const CancelBtn = styled(Button)`
  color: ${Black};
  border: 1px solid ${LightShadeGray};
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: all;
`;

export const ThreadDeleteMsg = styled.span`
  color: white;
  display: flex;
  justify-content: space-around;
`;

export const ThreadDeleteButtons = styled.span`
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
`;

export const ThreadButton = styled.span`
  padding: 0px 8px;
  margin: 8px;
  font-size: 12px;
  background: white;
  color: #007bff;
  border-radius: 4px;
  cursor: pointer;
`;
